import { createFileRoute, redirect } from "@tanstack/react-router";
import { resumeTarget } from "@vd/ui";

/**
 * `/resume`: where the customer app's Platform segment lands (DESIGN.md "Mode switch"). Signed
 * out, the layout sends the person to the passkey sign-in first and back here after. It opens
 * `to` when that is an ops page, else the last ops page this tab showed, else Companies.
 */
export const Route = createFileRoute("/_app/resume")({
  staticData: { crumb: { label: "Platform", parents: [] } },
  validateSearch: (s: Record<string, unknown>): { to?: string } =>
    typeof s.to === "string" && s.to ? { to: s.to } : {},
  beforeLoad: ({ search }) => {
    throw redirect({ href: resumeTarget("platform", search.to), replace: true });
  },
});
